module.exports = __webpack_public_path__ + "img/ico_rank_review_on.5007381.svg";